import { motion } from "framer-motion";
import Layout from "@/components/Layout";
import FanWall from "@/components/FanWall";

export default function FanWallPage() {
  return (
    <Layout>
      {/* Hero */}
      <section className="relative overflow-hidden py-20 md:py-28"
        style={{ background: "linear-gradient(135deg, #2d4a3e 0%, #1a2e27 60%, #3d2b1f 100%)" }}
      >
        {/* Floating birthday decorations */}
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          {["🎈","🎉","🎂","✨","🎈","🌹","🎉","✨","🎈"].map((icon, i) => (
            <motion.span
              key={i}
              className="absolute text-2xl select-none"
              style={{
                left: `${8 + i * 11}%`,
                top: `${10 + (i % 3) * 28}%`,
                opacity: 0.18 + (i % 3) * 0.07,
              }}
              animate={{ y: [0, -12, 0], rotate: [0, i % 2 === 0 ? 10 : -10, 0] }}
              transition={{ duration: 3 + i * 0.4, repeat: Infinity, ease: "easeInOut", delay: i * 0.3 }}
            >
              {icon}
            </motion.span>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="relative mx-auto max-w-2xl px-5 text-center"
        >
          <span className="text-5xl block mb-4">🎂</span>
          <p className="font-hand text-3xl text-gold mb-2">Agnes turns 107 on August 22nd!</p>
          <h1 className="font-serif text-4xl md:text-5xl font-bold tracking-tight text-cream leading-tight">
            Don't forget to sign<br />
            <span className="italic text-gold">the birthday card</span>
          </h1>
          <p className="mx-auto mt-5 max-w-lg leading-relaxed text-cream/75 text-base">
            Add your name, a birthday wish, and a sticker — your message joins everyone else's
            signatures on Agnes's special card. It takes just a moment and means the world. 💛
          </p>
          <button
            onClick={() => document.getElementById("card-section").scrollIntoView({ behavior: "smooth" })}
            className="mt-8 inline-flex items-center gap-2 rounded-full px-10 py-4 font-semibold text-forest transition-all hover:scale-105 active:scale-95"
            style={{ background: "linear-gradient(90deg, #d4a847 0%, #f0c060 100%)" }}
          >
            ✍️ Sign the Card
          </button>
        </motion.div>
      </section>

      {/* Card section */}
      <section id="card-section" className="py-14 md:py-20" style={{ background: "#f5ede0" }}>
        <div className="mx-auto max-w-6xl px-5">
          <FanWall />
        </div>
      </section>
    </Layout>
  );
}
